import React from 'react';

const PageHeader = ({ title, description, actions }) => (
  <div className="flex justify-between items-start mb-6">
    <div>
      <h4 className="font-serif text-xl text-gray-900 dark:text-gray-100 mb-1">{title}</h4>
      {description && (
        <p className="text-sm text-gray-500 dark:text-gray-400">{description}</p>
      )}
    </div>
    {actions && <div>{actions}</div>}
  </div>
);

export default PageHeader;
